/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useRef } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Modal, Button } from 'react-bootstrap';
import { ShareFill } from 'react-bootstrap-icons';
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import html2canvas from 'html2canvas';
import CardioResultPDF from '../components/CardioResultPDF';
import HRV from '../assets/SVG/summary-icon/hrv.svg';
import BP from '../assets/SVG/summary-icon/blood-pressure.svg';
import SPO2 from '../assets/SVG/summary-icon/oxygen-icon.svg';
import RR from '../assets/SVG/summary-icon/breathing-icon.svg';
import HR from '../assets/SVG/summary-icon/hr.svg';
// import HI from '../assets/SVG/summary-icon/water.svg';
// import AFib from '../assets/SVG/summary-icon/af.svg';
import Home from '../assets/SVG/buttons/Home-button-big.svg';
import Info from '../assets/SVG/buttons/info-button-blue-small.svg';
import TestButton from '../assets/SVG/buttons/Test-button.svg';
import Profile from '../assets/SVG/icons/Avatar.svg';
import Pinup from '../assets/SVG/icons/pinup.svg';
import Pindown from '../assets/SVG/icons/pindown.svg';
import ArrowUp from '../assets/SVG/icons/arrow-forward.svg';
import ArrowDown from '../assets/SVG/icons/arrow-down.svg';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import MotionError from '../assets/SVG/icons/motion-error-icon.svg';
import InfoErrorIcon from '../assets/SVG/icons/missing-information-icon.svg';
import config from '../config';
import '../styles/cardioresult.css';
axios.defaults.withCredentials = true;

export default function CardioResult(props) {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [open, setOpen] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isReady, setReady] = useState(false);
    const [pdfData, setPdfData] = useState(null);

    const [hrOpen, setHrOpen] = useState(true);
    const [rrOpen, setRrOpen] = useState(true);
    const [hrvOpen, setHrvOpen] = useState(true);
    const [spo2Open, setSpo2Open] = useState(true);
    const [bpOpen, setBpOpen] = useState(true);
    // const [hiOpen, setHiOpen] = useState(false);
    // const [afOpen, setAFOpen] = useState(false);
    // const [hiValue, setHiValue] = useState(null)

    const [state, setState] = useState({
        gender: true,
        dob: true
    });

    const user = useSelector(state => state.user);
    const motion = props.location.state?.motion;
    const width = props.location.state?.width;
    const height = props.location.state?.height;
    const totalTestTime = props.location.state?.timestamp[1199] - props.location.state?.timestamp[0];
    const motionThreshold = totalTestTime * 0.0625 * (200/480 * (Math.min(width, height)))/200 * 2;
    const hr = props.location.state?.cardio.hr?.value;
    const irregular_hr = props.location.state?.cardio.hr?.irregular;
    const confidence_hr = props.location.state?.cardio.hr?.confidence;
    const rr = props.location.state?.cardio.rr;
    const hrv = props.location.state?.cardio.hrv;
    const spo2 = props.location.state?.cardio.spo2;
    const af = props.location.state?.cardio.af;
    const diastolic_bp = props.location.state?.cardio.bp?.diastolic;
    const systolic_bp = props.location.state?.cardio.bp?.systolic;
    const sub_spo2 = (spo2-75)*4;
    const error = "Cannot confidently measure";

    const date = moment().tz(user?.timezone || config.defaultTimezone).format('YYYY-MM-DD');
    const time =  moment().tz(user?.timezone || config.defaultTimezone).format('hh:mm A');

    let bpColor = "";
    if(systolic_bp <120 || diastolic_bp < 80) {
        bpColor = "green"
    }
    if((120 <= systolic_bp && systolic_bp <=139) || (80 <= diastolic_bp && diastolic_bp <= 89)) {
        bpColor = "yellow"
    }
    if((140 <= systolic_bp && systolic_bp <=159) || (90 <= diastolic_bp && diastolic_bp <= 99)) {
        bpColor = "orange"
    }    
    if(systolic_bp >=160 || diastolic_bp >= 100) {
        bpColor = "red"
    }

    useEffect(() => {
        document.title = "Cardio measurement results";
        getUser();        
        getPdfData()
        // getHiValue();
    }, []);

    const gotoTestSelection = () => {
        // props.history.push("/testSelection")
        window.location.replace('/testSelection') // temp hotfix for memory leak for webgl
    }

    const getUser = () => {
        axios.get(config.backend_url + '/userdetails')
        .then((response) => {
            if (response.status === 200) {
                setState(prevState => ({
                    ...prevState,
                    gender: response.data.userDetails.gender === 'Not Selected' ? null : response.data.userDetails.gender,
                    dob: moment.utc(response.data.userDetails.dob).format('yyyy-MM-DD')
                }));
            } else {
                setState(prevState => ({
                    ...prevState,
                    gender: null,
                    dob: null
                }));
            }
            setLoading(false);
        })
        .catch ((error) => {
            console.error(error);
            setState(prevState => ({
                ...prevState,
                gender: null,
                dob: null
            }));
            setLoading(false);
        })
    };

    // const getHiValue = () => {
    //     const hi = props.location.state?.cardio.hi;
    //     if(hi && hi.total) {
    //         let total = hi.total.toFixed(2);
    //         if(hi.total < 0) total = 0;
    //         if(hi.total > 1) total = 1;
    //         setHiValue(total)
    //     }
    // }

    const toggleHr = () => setHrOpen(!hrOpen);
    const toggleRr = () => setRrOpen(!rrOpen);
    const toggleSpo = () => setSpo2Open(!spo2Open);
    const toggleHrv = () => setHrvOpen(!hrvOpen);
    const toggleBp = () => setBpOpen(!bpOpen);
    // const toggleHi = () => setHiOpen(!hiOpen);
    // const toggleAF = () => setAFOpen(!afOpen);

    const htmlToImage = async (content) => {
        const canvas = await html2canvas(content);
        const imgData = canvas.toDataURL('image/png');
        return imgData;
    }

    const getPdfData = async () => {
        const hr = document.getElementById('hr');
        const rr = document.getElementById('rr');
        const spo2 = document.getElementById('spo2');
        const hrv = document.getElementById('hrv');
        const bp = document.getElementById('bp');

        const hrImg = htmlToImage(hr);
        const rrImg = htmlToImage(rr);
        const spo2Img = htmlToImage(spo2);
        const hrvImg = htmlToImage(hrv);
        const bpImg = htmlToImage(bp);

        const results = await Promise.all([hrImg, rrImg, spo2Img, hrvImg, bpImg]);

        setHrOpen(false)
        setRrOpen(false)
        setHrvOpen(false)
        setSpo2Open(false)
        setBpOpen(false)
        setReady(true)
        setPdfData({
            results: results,
            name: `${user.firstName} ${user.lastName}`,
            date: `${date} ${time}`
        })
    }

    const onDownloadPDF = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false)
    }

    const downloadPDF = () => {
        const currentTimestamp = new Date().getTime();
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `Cardio-Result-${currentTimestamp}.pdf`;
        link.click();
        setOpen(false);
    }

    return (
        <div className="container">
            <div className="main cardio-result" data-testid="cardio-result">
                {isLoading && <div id="cover-spin" className='share_cardio'></div>}
                <div className="header" data-testid="header">
                    <img src={Home} alt="Home" onClick={() => props.history.push('/home')} data-testid="header-home-cta"/>
                    <img src={user.picture ? user.picture : Profile} alt="profile" className="mt-4 profile" onClick={()=>props.history.push('/navigation')}></img>
                    <img src={Info} alt="Info" onClick={() => props.history.push('/info')}/>
                </div>
                <div className='share_btn'>
                    {
                        isReady && pdfData !== null && <PDFDownloadLink document={<CardioResultPDF data={pdfData} />} fileName="covid_result.pdf">
                            {({ blob, url, loading, error }) => setPdfUrl(url)}
                        </PDFDownloadLink>
                    }
                    <div data-testid="share_icon" className='share_icon rounded-circle' onClick={(e) => onDownloadPDF()}><ShareFill size={20} color='#007bff' /></div>
                </div>
                <p className='mt-4 heading'>Cardio Result</p><p className='text-right font-size-14 mb-0 mr-3'>{date} at {time}</p>
                <div className='wrapper' data-testid="wrapper">
                    {(!(state.gender && state.dob) || motion > motionThreshold) ? 
                        <div className='error-wrapper p-3'>
                            {!(state.gender && state.dob) ? <p className='alert text-left'><img src={InfoErrorIcon} alt="error icon" className='mr-1' data-testid="no-gender-dob"/> Please provide us your Gender and Date of Birth to see more accurate results. You can update your profile <Link to='/update-profile'>here.</Link></p> : <></>}
                            {(motion > motionThreshold) ? <p className='motion-error text-left mt-2'><img src={MotionError} alt="motion icon" className='mr-1'/> The results might not be accurate due to excessive motion.</p> : <></>}
                        </div>
                    :<></>}
                    <div className='flex-row'>
                        <div className={isLoading ? "wrapper-small mt-0 pdf_share" : "wrapper-small  mt-0"} id='hr'>
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={HR} alt="hr"/><span>HEART RATE </span>
                                    <img src={hrOpen ? ArrowDown : ArrowUp} alt="hr-arrow" className='cursor-pointer' onClick={toggleHr}
                                        aria-controls="hr" aria-expanded={hrOpen} data-testid="toggle-hr"/>
                                </div>
                                <Collapse in={hrOpen}>
                                    <div id="hr">
                                        <div className='legend'>
                                            <span>Low</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Normal</span><div className='square-box green-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>High</span><div className='square-box orange-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                { hr && <><div className='pin' style={{left: `${hr/1.8}%`}}>
                                    <img src={Pinup} alt="pin"/><span className='pointer'>{hr}</span>
                                    </div>
                                    <div className='progressbar'><span className='yellow left-border-circle'/><span className='green'/><span className='orange right-border-circle'/></div>
                                    <div className='range'>
                                        <span>0</span><span>60</span><span>120</span><span>180</span>
                                    </div>
                                    <p className="text-right mb-0">bpm</p>
                                    {irregular_hr ? <div className="text-left"><img src={ErrorIcon} alt="error icon" /><span className='irregular'> Irregularity detected</span><br/></div> : <></>}
                                    {confidence_hr.includes('Low') ? <div className="text-left"><img src={ErrorIcon} alt="error icon" /><span className='irregular'> The HR value might not be accurate</span></div> : <></>}
                                </>}
                            </div>

                            {!hr && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}
                        </div>
                        <div className={isLoading ? "wrapper-small pdf_share" : "wrapper-small"} id='rr'>
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={RR} alt="rr"/><span>RESPIRATORY RATE </span>
                                    <img src={rrOpen ? ArrowDown : ArrowUp} alt="rr-arrow" className='cursor-pointer' onClick={toggleRr}
                                        aria-controls="rr" aria-expanded={rrOpen}/>
                                </div>
                                <Collapse in={rrOpen}>
                                    <div id="rr">
                                        <div className='legend'>
                                            <span>Low</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Normal</span><div className='square-box green-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>High</span><div className='square-box orange-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {rr && <><div className='pin' style={{left: `${rr/0.36}%`}}>
                                    <img src={Pinup} alt="pin"/><span className='pointer'>{rr}</span>
                                    </div> 
                                    <div className='progressbar'><span className='yellow left-border-circle'/><span className='green'/><span className='orange right-border-circle'/></div>
                                    <div className='range'>
                                        <span>0</span><span>12</span><span>24</span><span>36</span>
                                    </div>
                                    <p className="text-right mb-0">brpm</p>
                                </>}
                            </div>
                            {!rr && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}
                        </div>
                    </div>
                    <div className='flex-row'>
                        <div className={isLoading ? "wrapper-small pdf_share" : "wrapper-small"}  id='spo2'>
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={SPO2} alt="SpO2"/><span>OXYGEN (SPO<sub>2</sub>)</span>
                                    <img src={spo2Open ? ArrowDown : ArrowUp} alt="spo-arrow" className='cursor-pointer' onClick={toggleSpo}
                                        aria-controls="spo2" aria-expanded={spo2Open}/>
                                </div>
                                <Collapse in={spo2Open}>
                                    <div id="spo2">
                                        <div className='legend'>
                                            <span>95-100%-Normal</span><div className='square-box green-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>91-95%-Concerning</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>85-90%-Low</span><div className='square-box mustard-yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>80-85%-Low Effect your brain</span><div className='square-box orange-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>below 80%-Cyanosis</span><div className='square-box red-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {spo2 && <><div className='pin' style={{left: `${sub_spo2}%`}}>
                                        <img src={Pinup} alt="pin"/><span className='pointer font-size-9'>{spo2}%</span>
                                    </div>
                                    <div className='progressbar'>
                                        <span className='red left-border-circle'/><span className='orange'/><span className='mustard-yellow'/><span className='yellow'/><span className='green right-border-circle'/>
                                    </div>
                                    <div className='range'>
                                        <span>75%</span><span>80%</span><span>85%</span><span>90%</span><span>95%</span><span>100%</span>
                                    </div>
                                </>}
                            </div>
                            {!spo2 && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}
                        </div>
                        
                        <div className={isLoading ? "wrapper-small pdf_share" : "wrapper-small"} id='hrv'>
                            <div className="p-3">
                                <div className='text-left'>
                                    <img src={HRV} alt="hrv"/><span>HEART RATE VARIABILITY (HRV) </span>
                                    <img src={hrvOpen ? ArrowDown : ArrowUp} alt="hrv-arrow" className='cursor-pointer' onClick={toggleHrv}
                                        aria-controls="hrv" aria-expanded={hrvOpen}/>
                                </div>
                                <Collapse in={hrvOpen}>
                                    <div id="hrv">
                                        <div className='legend'>
                                            <span>Excellent</span><div className='square-box green-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Good</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Average</span><div className='square-box mustard-yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Below Average</span><div className='square-box orange-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Poor</span><div className='square-box red-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {hrv && <><div className='pin' style={{left: `${hrv/0.75}%`}}>
                                    <img src={Pinup} alt="pin"/><p className='pointer'>{hrv}</p>
                                    </div> 
                                    <div className='progressbar'>
                                    <span className='red left-border-circle'/><span className='orange'/><span className='mustard-yellow'/><span className='yellow'/><span className='green right-border-circle'/>
                                    </div>
                                    <div className='range'>
                                        <span>0</span><span>15</span><span>30</span><span>45</span><span>60</span><span>75</span>
                                    </div>
                                    <p className="text-right mb-0">ms</p>
                                </>}
                            </div>

                            {!hrv && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}  
                        </div>
                    </div>
                    <div className='flex-row mb-0'>
                        <div className={isLoading ? "wrapper-small pdf_share" : "wrapper-small"} id='bp'>
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={BP} alt="bp"/><span>BLOOD PRESSURE </span>
                                    <img src={bpOpen ? ArrowDown : ArrowUp} alt="bp-arrow" className='cursor-pointer' onClick={toggleBp}
                                        aria-controls="bp" aria-expanded={spo2Open}/>
                                </div>
                                <Collapse in={bpOpen}>
                                    <div id="bp">
                                        <div className='legend'>
                                            <span>Good</span><div className='square-box green-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Average</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Below Average</span><div className='square-box orange-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Poor</span><div className='square-box red-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {diastolic_bp && systolic_bp && <>
                                    <p className='bp-tag text-left mb-0'>Systolic</p>
                                    <div className='pin' style={{left: `${100 - systolic_bp/1.8}%`}}>
                                        <img src={Pinup} alt="pin"/><span className='pointer'>{systolic_bp}</span>
                                    </div>
                                    <div className={`progressbar ${bpColor}`}></div>
                                    <div className='range'>
                                        <span>180</span><span>144</span><span>108</span><span>72</span><span>36</span><span>0</span>
                                    </div>
                                    <div className='pin' style={{left: `${100 - diastolic_bp/1.8}%`}}>
                                        <img src={Pindown} alt="pin"/><span className='pointer-down'>{diastolic_bp}</span>
                                    </div>
                                    <p className='bp-tag text-right mb-0'>Diastolic</p>
                                    <p className="text-right mb-0">mmHg</p>
                                </>}
                            </div>

                            {(!diastolic_bp || ! systolic_bp) && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>} 
                        </div>
                        {/* <div className="wrapper-small">
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={AFib} alt="bp" width="38px" /><span>AFib</span>
                                    <img src={afOpen ? ArrowDown : ArrowUp} alt="bp-arrow" className='cursor-pointer' onClick={toggleAF}
                                        aria-controls="bp" aria-expanded={afOpen}/>
                                </div>
                                <Collapse in={afOpen}>
                                    <div id="bp">
                                        <div className='legend'>
                                            <span>Detected</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Not Detected</span><div className='square-box green-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {typeof af === "boolean" && <>
                                    <p className={`${af ? 'yellow-text' : 'green-text'} font-weight-bold bp-tag text-left afib`}>{af ? "AFib Detected" : "AFib Not Detected"}</p>
                                </>}
                            </div>

                            {typeof af !== "boolean" && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}
                        </div> */}
                        {/* <div className="wrapper-small">
                            <div className='p-3'>
                                <div className='text-left'>
                                    <img src={HI} alt="bp"/><span>HYDRATION INDEX</span>
                                    <img src={hiOpen ? ArrowDown : ArrowUp} alt="bp-arrow" className='cursor-pointer' onClick={toggleHi}
                                        aria-controls="bp" aria-expanded={hiOpen}/>
                                </div>
                                <Collapse in={hiOpen}>
                                    <div id="bp">
                                        <div className='legend'>
                                            <span>Low</span><div className='square-box yellow-legend'></div>
                                        </div>
                                        <div className='legend'>
                                            <span>Normal</span><div className='square-box green-legend'></div>
                                        </div>
                                    </div>
                                </Collapse>
                                {hiValue && <>
                                    <p className='bp-tag text-left mb-0 invisible'>HYDRATION INDEX</p>
                                    <div className='pin' style={{left: `${hiValue * 100}%`}}>
                                        <img src={Pinup} alt="pin"/><p className='pointer'>{hiValue}</p>
                                    </div> 
                                    <div className='progressbar'>
                                    <span className={`${hiValue > 0.5 ? 'green' : 'yellow'} left-border-circle right-border-circle`}/>
                                    </div>
                                    <div className='range'>
                                        <span className='text-left'>
                                            <span>0</span>
                                            <p className='bp-tag text-right mb-0 mt-1'>Dehydrated</p>
                                        </span>
                                        <span className='text-right'>
                                            <span>1</span>
                                            <p className='bp-tag text-right mb-0 mt-1'>Hydrated</p>
                                        </span>
                                    </div>
                                </>}
                            </div>

                            {!hiValue && <div className="disabled-div">
                                <p><img src={ErrorIcon} alt='error'/> {error}</p>
                            </div>}
                        </div> */}
                    </div>
                </div>
                <div className="buttons-div mt-3">
                    <div className='button'>
                        <img src={TestButton} alt='start-test' width="100px" height="100px" onClick={gotoTestSelection}/>
                        <span>Start</span>
                    </div>
                </div>
            </div>

            <Modal animation={false} show={open} onHide={handleClose} centered backdrop="static" className='warning_modal' data-testid="warning_modal">
                <Modal.Header>
                    <Modal.Title>Cardio Result Sharing</Modal.Title>
                </Modal.Header>
                <Modal.Body className="body">
                    <p>I understand that by sharing this information I am disclosing personal health information to the recipient and that the information shared is no longer protected by the iSelfie application privacy and security controls.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' id='cancel' data-testid="cancel" onClick={handleClose}>Cancel</Button>
                    <Button variant='primary' id='continue' data-testid="continue" onClick={downloadPDF}>Share</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
